import type { EnrichedReadyToSharePlatformPostV2 } from '#src/app/shared/api/readyToShare';

export type PostConfigRow = Readonly<{
	requiresRecommendedGroup: boolean;
	includeMessage: boolean;
	requiresGroupSelection?: boolean;
	desktopEnabled: boolean;
}>;

export const POST_CONFIGS: Readonly<Record<EnrichedReadyToSharePlatformPostV2['__typename'], PostConfigRow>> = {
	ReadyToShareFacebookPost: {
		requiresRecommendedGroup: false,
		includeMessage: true,
		desktopEnabled: true,
	},
	ReadyToShareFacebookGroupsPost: {
		requiresRecommendedGroup: true,
		includeMessage: true,
		requiresGroupSelection: true,
		desktopEnabled: true,
	},
	ReadyToShareFacebookStory: {
		requiresRecommendedGroup: false,
		includeMessage: false,
		desktopEnabled: false,
	},
	ReadyToShareInstagramPost: {
		requiresRecommendedGroup: false,
		includeMessage: true,
		desktopEnabled: false,
	},
	ReadyToShareInstagramStory: {
		requiresRecommendedGroup: false,
		includeMessage: false,
		desktopEnabled: false,
	},
	ReadyToShareRedditGroupsPost: {
		requiresRecommendedGroup: true,
		includeMessage: true,
		requiresGroupSelection: true,
		desktopEnabled: true,
	},
};
